export default {
  pages: {
    project: {
      sales: {
        waste: {
          tabIndex: 0
        },
        work: {
          tabIndex: 1
        },
        estimate: {
          tabIndex: 2
        },
        contract: {
          tabIndex: 3
        },
        instruction: {
          tabIndex: 4
        }
      }
    },
    estimate: {
      searchs: {
        customer: {
          name: 'customer',
          label: '得意先'
        },
        business_person: {
          name: 'business_person',
          label: '事業者'
        },
        workplace: {
          name: 'workplace',
          label: '事業場'
        },
        project: {
          name: 'project',
          label: '商流'
        },
        product_name: {
          name: 'product_name',
          label: '請求書表示用商品名'
        }
      }
    }
  }
};